import type { LabResultCategoryGroup } from '@liza/fhir-utils';
import { useLabResultCategoryLabel } from '../../hooks/useLabResultCategoryLabel';
import { LabCategoryMeasurements } from './LabCategoryMeasurements';

export type LabResultCategoryDetailProps = {
  category: LabResultCategoryGroup;
  /** Fired with a row's result code when its header is clicked — the single-lab detail. */
  onSelectLab?: (code: string) => void;
};

/**
 * Level 2: one category's labs as the care plan's detailed Results view. It opens with every lab's
 * trend combined onto one chart — the category is the subject, so the first thing to see is how its
 * labs move together — with the stacked per-lab charts and the duration toggle one click away. A
 * category with fewer than two trends has nothing to combine and opens stacked.
 */
export const LabResultCategoryDetail = ({
  category,
  onSelectLab,
}: LabResultCategoryDetailProps): React.ReactElement => {
  const labelFor = useLabResultCategoryLabel();

  return (
    <LabCategoryMeasurements
      category={category}
      detailed
      defaultCombined
      heading={labelFor(category.key)}
      onResultClick={onSelectLab}
      flagAbnormal
    />
  );
};
